import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App"
import { AuthProvider, type AuthAdapter } from "./auth"
import type { AppConfig } from "./api/types"
import { captureInviteFromHash } from "./pages/Join"
import "./styles.css"

captureInviteFromHash()

async function boot() {
	let adapter: AuthAdapter | undefined
	let config: AppConfig | undefined
	// `?fixtures=1` (dev server only): render the dashboard from local fixtures, no backend.
	if (import.meta.env.DEV && new URLSearchParams(location.search).has("fixtures")) {
		const f = await import("./dev/fixtures")
		;({ adapter, config } = f.installFixtures())
	}
	createRoot(document.getElementById("root")!).render(
		<StrictMode>
			<AuthProvider adapter={adapter} config={config}>
				<App />
			</AuthProvider>
		</StrictMode>,
	)
}
void boot()
